module.exports = ".well{\r\n    background-color: #f4f4f4 !important;\r\n  }\r\n  \r\n  .display-1 {\r\n      font-size: 36px;\r\n      font-weight: 300;\r\n      color: #757575;\r\n      padding: 1rem;\r\n  }\r\n  \r\n  .top-padding\r\n  {\r\n    padding-top: 20px;\r\n  }\r\n  \r\n  .upload-btn\r\n  {\r\n    min-height: 42px;\r\n  }\r\n  "


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/batch-job/batch-job.component.css
// module id = ./src/app/modules/batch-job/batch-job.component.css
// module chunks = main